import React, { Component, useState, useEffect } from "react";
import "../index.css";
import { MDBRow, MDBCol } from "mdbreact";
import { NavLink, withRouter } from "react-router-dom";
import DashboardNavBar from "../Layout/DashboardNavBar";
import DashboardFooter from "../Layout/DashboardFooter";
import { firebase } from "../../../firebase/config";
import "react-phone-number-input/style.css";
import { BiChevronDown, BiLinkAlt } from "react-icons/bi";
// import Heading from "./Heading";
import { FiArrowUpRight, FiRefreshCw, FiChevronRight } from "react-icons/fi";
import { FaChevronRight } from "react-icons/fa";

const Privacy = ({ email, popUpVisible, setPopUpVisible, ref, seconds }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [uploadOptionsVisible, setUploadOptionsVisible] = useState(false);
  const [uploading, setUploading] = useState(true);
  const [youtubeLink, setYoutubeLink] = useState(null);
  const [uploadingArray, setUploadingArray] = useState([]);
  const [historyArray, setHistoryArray] = useState([]);
  const [processingArray, setProcessingArray] = useState([]);
  const [videoVisible, setVideoVisible] = useState(false);
  const [currentVideo, setCurrentVideo] = useState(null);
  const [freeTrialUsed, setFreeTrialUsed] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  useEffect(() => {
    if (firebase.auth().currentUser) {
      const uid = firebase.auth().currentUser.uid;

      firebase
        .firestore()
        .collection("users")
        .doc(uid)
        .onSnapshot((doc) => {
          setFreeTrialUsed(doc.data().freeTrialUsed);
        });

      firebase
        .firestore()
        .collection("customers")
        .doc(uid)
        .collection("subscriptions")
        .where("status", "==", "active")
        .onSnapshot((querySnapshot) => {
          if (!querySnapshot.empty) {
            let initActive = [];
            querySnapshot.forEach((doc) => {
              console.log(doc.data());
              initActive.push(doc.data());
            });
            if (initActive.length > 0) {
              setSubscribed(true);
            }
          } else {
            setSubscribed(false);
          }
        });
      console.log(uid);
      firebase
        .firestore()
        .collection("users")
        .doc(uid)
        .collection("tasks")
        .onSnapshot((querySnapshot) => {
          if (!querySnapshot.empty) {
            let initArray = [];
            let processArray = [];
            let uploadArray = [];
            querySnapshot.forEach((doc) => {
              console.log(doc.data());
              if (doc.data().status === "Complete") {
                initArray.push(doc.data());
              } else if (
                doc.data().status !== "Error" &&
                doc.data().status !== "Complete" &&
                doc.data().status !== "Uploading"
              ) {
                setUploading(false);
                processArray.push(doc.data());
              } else if (doc.data().status === "Uploading") {
                setUploading(true);
                uploadArray.push(doc.data());
              }
            });

            console.log("The init array is,", initArray);
            setHistoryArray(initArray);
            setProcessingArray(processArray);

            setUploadingArray(uploadArray);
          }
        });
    }
  }, [firebase.auth().currentUser]);

  useEffect(() => {
    setPopUpVisible(false);
  }, []);

  useEffect(() => {
    console.log("Uploading array is", uploadingArray);
  }, [uploadingArray]);

  useEffect(() => {
    setYoutubeLink("");
  }, [modalVisible]);

  return (
    <>
      <div
        style={{
          overflowX: "hidden",
          height: "100vh",
        }}
      >
        <div
          style={{
            overflowX: "hidden",
            paddingBottom: 0,
            height: "100vh",
            color: "rgb(242, 241, 243)",
            backgroundColor: "#121114",
          }}
        >
          <MDBCol
            style={{
              width: "105vw",
              overflowX: "hidden",
              paddingBottom: 0,
              paddingBottom: 95,
            }}
            size="12"
          >
            <MDBRow style={{ marginTop: 0 }}>
              <DashboardNavBar
                popUpVisible={popUpVisible}
                setPopUpVisible={setPopUpVisible}
                email={email}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                seconds={seconds}
                ref={ref}
              />
            </MDBRow>
            <MDBCol
              className="d-flex justify-content-center"
              style={{ marginTop: 150 }}
              size="12"
            >
              <MDBRow style={{ width: 1340, paddingLeft: 20 }}>
                <MDBCol size="12">
                  <p style={{ fontSize: 49, fontFamily: "PPBold" }}>
                    Privacy Policy
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 25,
                      fontFamily: "PPBold",
                      marginTop: 20,
                    }}
                  >
                    Last Updated: 27/10/2023
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 25,
                      fontFamily: "PPBold",
                      marginTop: 20,
                    }}
                  >
                    Introduction
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    Welcome to Cloneshort. This Privacy Policy outlines how we
                    collect, use, and protect your personal information. By
                    using our services, you agree to the terms of this Privacy
                    Policy.
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 25,
                      fontFamily: "PPBold",
                      marginTop: 20,
                    }}
                  >
                    Information We Collect
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    1. Personal Information: This includes your email address,
                    and payment details.
                  </p>
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    2. Usage Data: We collect data related to your use of our
                    service, such as the type of content you generate.
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 25,
                      fontFamily: "PPBold",
                      marginTop: 20,
                    }}
                  >
                    How We Use Your Information
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    1. Service Provision: To provide and maintain our services.
                  </p>
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    2. Improvement: To improve and personalize your experience.
                  </p>
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    3. Communication: To communicate with you about updates,
                    promotions, and customer service.
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 25,
                      fontFamily: "PPBold",
                      marginTop: 20,
                    }}
                  >
                    Data Sharing and Third Parties
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    1. We do not sell or share your personal information with
                    third parties for their marketing purposes.
                  </p>
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    2. We may share data with service providers who assist in
                    our operations.
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 25,
                      fontFamily: "PPBold",
                      marginTop: 20,
                    }}
                  >
                    Data Security
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    We implement robust security measures to protect your data.
                    However, no method of transmission or storage is 100%
                    secure.
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 25,
                      fontFamily: "PPBold",
                      marginTop: 20,
                    }}
                  >
                    Cookies
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    We use cookies to enhance your experience. You can opt-out
                    by changing your browser settings.
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 25,
                      fontFamily: "PPBold",
                      marginTop: 20,
                    }}
                  >
                    Your Rights
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    1. You have the right to access, correct, or delete your
                    personal information.
                  </p>
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    2. You can opt-out of receiving marketing communications
                    from us.
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 25,
                      fontFamily: "PPBold",
                      marginTop: 20,
                    }}
                  >
                    Changes to This Policy
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    We may update this Privacy Policy at any time. Changes will
                    be posted on this page and are effective immediately.
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 25,
                      fontFamily: "PPBold",
                      marginTop: 20,
                    }}
                  >
                    Governing Law
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    This Privacy Policy is governed by the laws of the United
                    Kingdom, without regard to its conflict of law principles.
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 25,
                      fontFamily: "PPBold",
                      marginTop: 20,
                    }}
                  >
                    Contact Us
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    For any questions or concerns about this Privacy Policy,
                    please contact us at help@cloneshort.com
                  </p>
                </MDBCol>
              </MDBRow>
            </MDBCol>

            {firebase.auth().currentUser ? null : (
              <>
                {/* <Explainer />
                {/* <Process /> */}
                {/* <Steps />
                <Pricing />
                <div style={{ marginTop: 50 }}></div>
                <Questions />  */}
              </>
            )}
          </MDBCol>
          <div
            style={{
              backgroundColor: "#30312c",
              position: "absolute",
              bottom: 20,
              right: 30,
              height: 46,
              width: 320,
              borderRadius: 8,
              color: "white",
              fontFamily: "PPMedium",
              textAlign: "center",
              cursor: "pointer",
              opacity: 1,
              zIndex: 9000,
            }}
            className="d-flex justify-content-center"
          >
            <p style={{ marginTop: 13, fontSize: 15 }}>
              Have questions? Join our Discord{" "}
              <FaChevronRight
                style={{ fontSize: 12, marginLeft: 6, marginTop: -2.67 }}
                className="d-inline"
              />
            </p>
          </div>
          <DashboardFooter />
        </div>
      </div>
    </>
  );
};

export default withRouter(Privacy);
